import { BrowserRouter, Switch, Route } from "react-router-dom";

import View404 from "../VIEWS/404";
import DominioIncorrecto from "../VIEWS/DominioIncorrecto";
// PRUEBA 
import Pruebas                from "../VIEWS/Pruebas/prueba";
import GARITA                 from "../VIEWS/GARITA/01_GARITA"; 



import App from "../App";

export default function RoutesMain() {
  return (
    <BrowserRouter>
      <Switch>
        <Route component={GARITA} path="/" exact />

     


            {/*  Prueba */}
            <Route component={Pruebas} path="/Prueba" exact />



        {/*  ERROR */}
        <Route component={View404} path="*" exact />

      </Switch>
    </BrowserRouter>
  );
}
